import React, { Fragment } from "react";

import TablaDetalleArticulo from './detalleArticulo.jsx';

const fontStyles = { fontSize: '14px', fontFamily: 'monospace', lineHeight: '1.5' };

const detalleSucursal = props => {

    const { articulos, sucursal } = props;
    const articulosSucursal = articulos.filter(item => item.Suc_Id === sucursal);
    const Suc_Nombre = articulosSucursal[0].Suc_Nombre;
    const movimiento = sucursal !== articulosSucursal[0].Sucursal_Factura ?
        <p style={fontStyles}>{`Movimiento aplicado: ${articulosSucursal[0].Mov_Estado === 'AP' || articulosSucursal[0].Mov_Estado === 'RE' ? 'SI' : 'NO'}`}</p>
        : null;

    return articulosSucursal.length > 0 ?
        <Fragment>
            <b style={fontStyles}>{`Sucursal: ${Suc_Nombre}`}</b>
            {movimiento}
            <TablaDetalleArticulo articulos={articulosSucursal} />
        </Fragment >
        : null;
}

export default detalleSucursal;